import { render, staticRenderFns } from "./location-category.vue?vue&type=template&id=7c4d3e8b&scoped=true"
import script from "./location-category.vue?vue&type=script&lang=js"
export * from "./location-category.vue?vue&type=script&lang=js"
import style0 from "./location-category.vue?vue&type=style&index=0&id=7c4d3e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d3e8b",
  null
  
)

export default component.exports